"use strict";

!(function ($) {
  let instafeedInited = false;
  if ($(".slider_block_inner").length) {
    $(".slider_block_inner").slick({
      centerMode: true,
      arrows: true,
      dots: false,
      slidesToShow: 1,
      speed: 500,
      fade: true,
      cssEase: "linear",
    });
  }
  function mobile_only_carousel() {
    if ($(".bottom_block_carousel").length) {
      if ($(window).width() <= 767.98) {
        $(".bottom_block_carousel").slick({
          arrows: false,
          dots: true,
          slidesToShow: 1,
          adaptiveHeight: true,
        });
      } else {
        $(".bottom_block_carousel").slick("unslick");
      }
    }
  }
  mobile_only_carousel();
  $(window).resize(function () {
    mobile_only_carousel();
  });
})(jQuery);
